import { createFileRoute } from "@tanstack/react-router";

import { UpravenOdborPage } from "../about_.upraven-odbor";

export const Route = createFileRoute("/en/about_/upraven-odbor")({
	headers: () => ({
		"Cache-Control":
			"public, max-age=0, s-maxage=86400, stale-while-revalidate=604800",
	}),
	head: () => ({
		meta: [
			{ title: "Management Board | Makedonijaturist AD" },
			{
				name: "description",
				content:
					"Members of the Management Board of Makedonijaturist AD. Leadership and management of the largest hotel group.",
			},
		],
		links: [
			{
				rel: "canonical",
				href: "https://makedonijaturist.com.mk/en/about/upraven-odbor",
			},
		],
	}),
	component: UpravenOdborPage,
});
